import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'gsp-base-header-layout',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class BaseHeaderLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
